import axios from "axios";
import { AuthURL } from "../../../config/UrlEndPoint";

export const URL = `${AuthURL}`;

export function updateProfile(params) {
  return axios.put(`${URL}update`, params);
}
